import { computed, type MaybeRefOrGetter, toValue } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { getOrganizationOnboarding } from '@/features/organizations/api/get-organization-onboarding'

/** Prefix of every onboarding query; invalidate it after a change to an organization's first website. */
export const ORGANIZATION_ONBOARDING_QUERY_KEY = ['organizations', 'onboarding'] as const

/** Idle while `organizationId` is null. */
export function useOrganizationOnboarding(organizationId: MaybeRefOrGetter<number | null>) {
  return useQuery({
    queryKey: computed(() => [...ORGANIZATION_ONBOARDING_QUERY_KEY, toValue(organizationId)]),
    queryFn: () => getOrganizationOnboarding(toValue(organizationId) as number),
    enabled: computed(() => toValue(organizationId) !== null),
  })
}
